import React from 'react';
import { observer } from 'mobx-react-lite';
import { Route, RouteProps, Redirect } from 'react-router-dom';

import { useStore } from '@src/models';

export type AuthRouteProps = RouteProps & { component: React.ReactNode };
export const AuthRoute = observer(({ component: Component, location, ...rest }: AuthRouteProps) => {
  const {
    authStore: { isFetching, isAuthorized },
    userStore: { defaultPrivateRoute }
  } = useStore();

  if (isFetching && location.pathname !== defaultPrivateRoute) {
    return null;
  }
  return (
    <Route
      render={props => (isAuthorized ? <Redirect to={defaultPrivateRoute} /> : <Component {...props} />)}
      {...rest}
    />
  );
});
